import React from "react";

const CabinBookigRoute = ({ children }) => {
  return children;
};

export default CabinBookigRoute;
